import { CommonRepositoryParams, getAppConfiguration } from '@mews-commander/data-access';
import { getCurrentEnterpriseId, getCurrentProfileIdOrNull } from '@mews-commander/core';
import { APP_API_IDENTIFIER } from '@mews-commander/constants';

const getClient = () => `${APP_API_IDENTIFIER} ${getAppConfiguration().version}`;

export const getCommonParams = (): CommonRepositoryParams => ({
    client: getClient(),
    enterpriseId: getCurrentEnterpriseId(),
    profileId: getCurrentProfileIdOrNull() ?? undefined,
});
